import { render, staticRenderFns } from "./LProjectModalConfigurationChanges.vue?vue&type=template&id=3300d43d&"
import script from "./LProjectModalConfigurationChanges.vue?vue&type=script&lang=js&"
export * from "./LProjectModalConfigurationChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports